import { createFileRoute, notFound } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { verifyAdminAccess } from "@/lib/admin-guard.functions";

// Code-split: the operations console UI is only fetched after the server
// has confirmed the caller is an admin. Public bundles never include it.
const OpsConsole = lazy(() => import("@/components/AdminConsole"));

export const Route = createFileRoute("/wtb-ops-control")({
  // No head() title — keep this surface invisible to crawlers / link previews.
  ssr: false,
  beforeLoad: async () => {
    try {
      await verifyAdminAccess();
    } catch {
      throw notFound();
    }
  },
  notFoundComponent: NotFoundPage,
  errorComponent: NotFoundPage,
  component: () => (
    <Suspense fallback={null}>
      <OpsConsole />
    </Suspense>
  ),
});

function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
      <div className="text-center">
        <h1 className="font-display text-6xl font-bold">404</h1>
        <p className="mt-2 text-muted-foreground">Page not found.</p>
      </div>
    </div>
  );
}
